<template>
  <article>
    <p class="subtitle">You might also like these games</p>
    <section class="card-deck">
      <Card
        v-for="(data, index) in posts.data"
        :key="index"
        :slug="data.slug"
        :image1="data.image1"
        :title="data.title"
      />
    </section>
  </article>
</template>


<script>
import api from "@/api";
import Card from "@/components/Card";

export default {
  name: "RandomList",
  components: {
    Card,
  },
  data() {
    return {
      posts: {},
    };
  },

  mounted() {
    this.getResults();
  },

  watch: {
    $route: function (to, from) {
      if (from.name == "Rom" || to.name == "Rom") {
        this.getResults();
      }
    },
  },

  methods: {
    async getResults() {
      await api.get("post/random").then((response) => {
        this.posts = response;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/RandomList.vue